import React from 'react';
import { AiOutlineUser } from 'react-icons/ai';
import { LogOut } from 'lucide-react';
import { isCustomerLoggedIn, logoutCustomer } from '../utils/auth';

interface CustomerAuthActionsProps {
  customerName: string | null;
  accountHref?: string;
  loginHref?: string;
  logoutHref?: string;
}

const CustomerAuthActions: React.FC<CustomerAuthActionsProps> = ({
  customerName,
  accountHref = '/my-account',
  loginHref = '/login',
  logoutHref = '/',
}) => {
  const loggedIn = isCustomerLoggedIn();

  const handleLogout = () => {
    logoutCustomer();
    window.location.assign(logoutHref);
  };

  return (
    <>
      <li className="nav-item">
        <a
          href={accountHref}
          className="nav-link d-flex align-items-center"
          style={{ gap: '6px' }}
        >
          <AiOutlineUser size={24} style={{ color: '#898989' }} />
          {loggedIn && customerName ? (
            <span
              style={{
                fontSize: '14px',
                color: '#999',
                maxWidth: '120px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
              title={`Hi, ${customerName}`}
            >
              Hi, {customerName}
            </span>
          ) : (
            <span
              style={{
                fontSize: '14px',
                color: '#999',
              }}
            >
              Account
            </span>
          )}
        </a>
      </li>

      {loggedIn && (
        <li className="nav-item ml-2">
          <button
            onClick={handleLogout}
            title="Sign out"
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '4px 6px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <LogOut size={22} color="#898989" />
          </button>
        </li>
      )}
    </>
  );
};

export default CustomerAuthActions;